import { render, staticRenderFns } from "./ICheckbox.vue?vue&type=template&id=8f60309c&"
import script from "./ICheckbox.vue?vue&type=script&lang=js&"
export * from "./ICheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ICheckbox.vue?vue&type=style&index=0&id=8f60309c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports